import cloudServiceModule from '../cloudService.module';

class CountryApiService {
    constructor(__env, $http, $q) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
    }

    getCountries() {
        var deferred = this.$q.defer();
        this.$http
            .get(`${this.__env.cloudApiUrl}/api/v2/countries`)
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );
        return deferred.promise;
    }
}

export default cloudServiceModule.service(
    'countryApiService',
    CountryApiService
);



// WEBPACK FOOTER //
// ./modules/cloudService/countryApi/countryApi.service.js